const YM_COUNTER_ID = 13946815;

export function getYaMetrikaClientId() {
    let result = '';
    if (! window.ym) {
        console.warn('getYaMetrikaClientId: Ya.Metrika counter not found')
        return result;
    }

    ym(YM_COUNTER_ID, 'getClientID', clientID => {
        result = clientID;
    });
    return result;
}


/**
 * Отправляет событие достижения цели в Яндекс.Метрику
 * @param {string} event_name  ID события
 */
export function sendYaMetrikaGoal(event_name) {
  if ( window?.ym ) {
    window.ym(YM_COUNTER_ID, 'reachGoal', event_name);
    console.info( 'Event (name:' + event_name +  ') triggered for Yandex.Metrica counter id:' + YM_COUNTER_ID);
  } else {
    console.warn( 'Yandex.Metrica counter id:' + YM_COUNTER_ID + ' doesn\'t exists for event: ' + event_name );
  }
}
